import { render, staticRenderFns } from "./ImageBlock.vue?vue&type=template&id=76ffa964&scoped=true"
import script from "./ImageBlock.vue?vue&type=script&lang=js"
export * from "./ImageBlock.vue?vue&type=script&lang=js"
import style0 from "./ImageBlock.vue?vue&type=style&index=0&id=76ffa964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ffa964",
  null
  
)

export default component.exports